import { Component, h } from 'preact'
import Panel from '../panel'
import ButtonControl from '../button-control'
import Switcher from '../control/Switcher'
import Tooltip from '../ui-components/Tooltip'
import DropdownControl from '../dropdown/DropdownControl'
import salesforceLanguages from './assets/SalesforceLanguages'
import axios from 'axios'

interface Props {
  federatedSearchLanguage: string,
  enableFederatedSearch: boolean,
  successCallback: (message: string) => void,
  errorCallback: (message: string) => void
}

interface State {
    messageType?: string|null,
    message?: string,
    enableFederatedSearch: boolean,
    syncInProgress: boolean,
  showLanguageError: boolean,
    locale: null | {
      title: string,
      value: string
    }
}

class SalesforceFederatedSearch extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      locale: props.federatedSearchLanguage === '' ? null : {
        value: props.federatedSearchLanguage,
        title: salesforceLanguages.filter(salesforceLanguage => salesforceLanguage.value === props.federatedSearchLanguage)[0].title
      },
      messageType: null,
      message: '',
      enableFederatedSearch: props.enableFederatedSearch,
      syncInProgress: false,
      showLanguageError: false
    }
    this.onFederatedSearchToggle = this.onFederatedSearchToggle.bind(this)
    this.onSync = this.onSync.bind(this)
  }

  async onFederatedSearchToggle () {
    if (!this.state.locale) {
      this.setState({ showLanguageError: true })
    } else {
      try {
        const response = await axios.post('/integration/salesforce/toggleFederatedSearch', {
          isActive: !this.state.enableFederatedSearch,
          locale: this.state.locale.value
        })
        const successMessage = !this.state.enableFederatedSearch ? `Federated search is enabled on your community. ${response.data.count} Salesforce articles are successfully synchronized!` : 'Federated search is disabled on your community.'
        this.props.successCallback(successMessage)
        this.setState({ enableFederatedSearch: !this.state.enableFederatedSearch })
      } catch (e) {
        this.props.errorCallback('Something went wrong')
      }
    }
  }

  async onSync () {
    this.setState({ syncInProgress: true })

    try {
      const res = await axios.post('/integration/salesforce/sync', [])
      const successMessage = `${res.data.count} Salesforce articles are successfully synchronized!`
      this.props.successCallback(successMessage)
    } catch (e) {
      this.props.errorCallback('Sorry, synchronisation failed, please try again.')
    }
    this.setState({ syncInProgress: false })
  }

  render (props: Props, state: State) {
    return (
      <Panel title='Federated search' class='integrations-panel-with-margin' collapsible>
        <div className='form-group'>
          <DropdownControl
            align='adjust'
            trigger={<ButtonControl
              class={`integrations-salesforce_language-selector ${!state.locale ? 'empty' : ''} ${state.showLanguageError ? 'error' : ''}`}
              title={state.locale ? `${state.locale.title}: ${state.locale.value}` : 'Select a language'}
              icon={'arrowDropdown'} />}
            items={
              salesforceLanguages.map((salesforceLanguage: { title: string, value: string }) => ({
                title: `${salesforceLanguage.title}: ${salesforceLanguage.value}`,
                value: salesforceLanguage.value,
                onClick: () => this.setState({ locale: salesforceLanguage, showLanguageError: false })
              }))
            }
            hasSearch
          />
          {state.showLanguageError && <span class='validation-error error-message'>Please select a language first</span>}
        </div>
        <div className='form-group'>
          <div className='clearfix'>
            <div className='col-md-6'>
              <Switcher
                on={state.enableFederatedSearch}
                label='Enable federated search'
                onChange={this.onFederatedSearchToggle} />
            </div>

            {
              state.enableFederatedSearch ? (
                <div className='col-md-6'>
                  <ButtonControl
                    variant='secondary'
                    title='Synchronize articles'
                    isLoading={state.syncInProgress}
                    onClick={this.onSync} />
                  <Tooltip
                    trigger={<i className='fa fa-question-circle' />}
                    customClasses='integrations-salesforce__sync-tooltip'
                    tooltipMessage='Search index from Salesforce are updated every day. Click this button to trigger a full synchronisation if needed.'
                  />
                </div>
              ) : null
            }
          </div>
        </div>
      </Panel>
    )
  }
}

export default SalesforceFederatedSearch
